export const emailSubmitSelector = ".email-submit-attach-clk";
export const lockSelector = '.lock-attach-clk';
export const dataContainerSelector = ".datacontainer"